import React, { Fragment, useEffect, useState } from 'react'
import { connect, useSelector } from 'react-redux'
import { api } from '../../services'
import QuestHeader from './components/QuestHeader'
import { useTranslation } from 'react-i18next'
import { Spin, Table, Button, Modal, Tag, Icon, Pagination, Typography, Row, Col, Form, Input, InputNumber, message, Tooltip, Select } from 'antd'
import history from '../../history'
import './quest.scss'
const { Title, Text } = Typography
const { Option } = Select

const ListQuest = ({ user }) => {
    const { t } = useTranslation()
    const { active_organization_id, id: user_id } = user?.info
    const [isFetching, setIsFetching] = useState(false)
    const [hunts, setHunts] = useState([])
    const [total, setTotal] = useState(0)
    const [query, setQuery] = useState({
        org_id: String(active_organization_id),
        user_id: String(user_id),
        limit: 100,
        offset: 0
    })

    const [isModalVisible, setIsModalVisible] = useState(false)
    const [selectedHunt, setSelectedHunt] = useState(null)
    const [activeIndex, setActiveIndex] = useState(null)
    const [users, setUsers] = useState([])
    // const { list: { rows: orgList = [] } } = useSelector(state => state.organizations)
    // const { groups: groupList = [] } = orgList.find(org => org.id === active_organization_id) || {}

    useEffect(() => {
        getQuestContent()
    }, [query])

    const ageGroupOptions = [
        { label: 'Preschool (3-5)', value: '3-5' },
        { label: 'Elementary (6-10)', value: '6-10' },
        { label: 'Middle School (11-13)', value: '11-13' },
        { label: 'High School (14-18)', value: '14-18' },
        { label: 'Adults (18+)', value: '18+' }
    ]

    const getQuestContent = async () => {
        setIsFetching(true)
        try {
            const res = await api.quest.getQuestContent(query)
            if (res?.data) {
                const huntsWithKeys = (res.data.hunts || []).map((hunt, index) => ({
                    ...hunt,
                    key: `hunt-${index}-${hunt.id || hunt.hunt_id || Date.now()}`
                }))
                setHunts(huntsWithKeys)
                const apiCount = Number(res.data.count || 0)
                setTotal(Math.max(apiCount, huntsWithKeys.length))
            }
        } catch (error) {
            console.error('Error fetching quests:', error)
        } finally {
            setIsFetching(false)
        }
    }

    const handleView = (hunt) => {
        setSelectedHunt(hunt)
        setIsModalVisible(true)
    }

    const togglePanel = (index) => {
        setActiveIndex(prev => (prev === index ? null : index))
    }

    const handlePageChange = (page, pageSize) => {
        setQuery(prev => ({
            ...prev,
            limit: pageSize,
            offset: (page - 1) * pageSize
        }))
    }

    const handleCloseMainModal = () => {
        setIsModalVisible(false)
    }



    const columns = [
        {
            title: 'Quest Title',
            dataIndex: 'title',
            key: 'title',
            render: text => <span style={{ fontWeight: 600 }}>{text}</span>
        },
        {
            title: 'Age Group',
            dataIndex: 'age_group',
            key: 'age_group',
            render: age => {
                const option = ageGroupOptions.find(opt => opt.value === age)
                return <Tag color="blue">{option ? option.label : age}</Tag>
            }
        },
        {
            title: 'Total Stops',
            key: 'stops',
            render: (text, record) => (
                <Tag color="purple">{record.stops?.length || 0} Stops</Tag>
            )
        },
        {
            title: 'Actions',
            key: 'action',
            width: 120,
            align: 'right',
            render: (text, record) => (
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
                    <Tooltip title="View Quest">
                        <Icon
                            type="eye"
                            style={{
                                color: '#1890ff',
                                fontSize: '18px',
                                cursor: 'pointer',
                                padding: '4px',
                                borderRadius: '4px',
                                transition: 'all 0.3s',
                                background: 'rgba(24, 144, 255, 0.05)'
                            }}
                            className="action-icon-hover"
                            onClick={() => handleView(record)}
                        />
                    </Tooltip>
                    <Tooltip title="Delete Quest">
                        <Icon
                            type="delete"
                            style={{
                                color: '#ff4d4f',
                                fontSize: '18px',
                                cursor: 'pointer',
                                padding: '4px',
                                borderRadius: '4px',
                                transition: 'all 0.3s',
                                background: 'rgba(255, 77, 79, 0.05)'
                            }}
                            className="action-icon-delete"
                            onClick={() => {
                                Modal.confirm({
                                    title: 'Delete Quest',
                                    content: `Are you sure you want to delete "${record.title}"? This action cannot be undone.`,
                                    okText: 'Yes, Delete',
                                    okType: 'danger',
                                    cancelText: 'Cancel',
                                    centered: true,
                                    onOk: () => deleteQuest(record.hunt_id)
                                });
                            }}
                        />
                    </Tooltip>
                </div>
            )
        }
    ]
    const getUserList = async () => {
        try {
            const res = await api.quest.getUserList({ org_id: active_organization_id, limit: 50 })
            if (res.data) {
                setUsers(res.data?.users || [])
            }
        } catch (error) {
            console.error('Error fetching users:', error)
        }
    }
    const deleteQuest = async (hunt_id) => {
        try {
            const res = await api.quest.deleteQuest(hunt_id, user_id)
            if (res.data) {
                message.success('Quest deleted successfully')
                getQuestContent()
            }
        } catch (error) {
            console.error('Error fetching users:', error)
            message.error('Only the creator can delete this hunt.')

        }
    }
    return (
        <Fragment>

            <section className="section" style={{ paddingBottom: '10rem' }}>
                <QuestHeader t={t} type={"List"} />
                <div style={{ marginTop: '2rem' }}>
                    <div style={{
                        background: '#fff',
                        padding: '24px 32px',
                        borderRadius: '8px',
                        marginBottom: '24px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                        borderBottom: '3px solid #1890ff',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                    }}>
                        <div>
                            <Title level={2} style={{ margin: 0, color: '#262626' }}>Quest Management</Title>
                            <Text type="secondary" style={{ fontSize: '14px' }}>
                                View, monitor and manage all your generated quests
                            </Text>
                        </div>
                        <Button
                            type="primary"
                            icon="plus"
                            size="large"
                            className="rounded"
                            onClick={() => history.push('/quest-create')}
                        >
                            Create New Quest
                        </Button>
                    </div>

                    <Spin spinning={isFetching}>
                        <div className="form-body">
                            <Table
                                columns={columns}
                                dataSource={hunts}
                                pagination={false}
                            />
                            <div style={{ marginTop: '2rem', display: 'flex', justifyContent: 'flex-end' }}>
                                <Pagination
                                    current={(query.offset / query.limit) + 1}
                                    total={total}
                                    pageSize={query.limit}
                                    onChange={handlePageChange}
                                    onShowSizeChange={handlePageChange}
                                />
                            </div>
                        </div>
                    </Spin>
                </div>
            </section>

            <Modal
                title={selectedHunt ? `${selectedHunt.title}` : 'Quest Stops'}
                visible={isModalVisible}
                onCancel={handleCloseMainModal}
                footer={[
                    selectedHunt && (
                        <Button
                            key="edit"
                            type="primary"
                            className="rounded"
                            onClick={() => history.push(`/quest-create?hunt_id=${selectedHunt.id || selectedHunt.hunt_id}`)}
                        >
                            Edit Quest
                        </Button>
                    ),
                    <Button key="close" className="rounded" onClick={handleCloseMainModal}>
                        Close
                    </Button>
                ].filter(Boolean)}
                width={'75%'}
                centered
            >
                <Spin spinning={isFetching}>
                    {selectedHunt && (
                        <div className="objectives-box">
                            <h4 className="corporate-label">
                                <Icon type="rocket" /> Quest Objectives
                            </h4>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                <p className="objectives-text" style={{ flex: 1, marginRight: '20px' }}>{selectedHunt.objectives}</p>
                            </div>
                        </div>
                    )}

                    {selectedHunt && (
                        <div className="accordion">
                            {(selectedHunt.stops || []).map((content, index) => (
                                <div className="accordion__item" key={index}>
                                    <div
                                        className={`accordion__header ${activeIndex === index ? 'active' : ''}`}
                                        onClick={() => togglePanel(index)}
                                    >
                                        <div className="accordion__title">
                                            <span className="accordion__step-num">#{content.number || index + 1}</span>
                                            {content.title}
                                            {content.objective && (
                                                <Tooltip title={content.objective} placement="top">
                                                    <Icon
                                                        type="info-circle"
                                                        style={{ marginLeft: 8, color: '#1890ff', cursor: 'help' }}
                                                    />
                                                </Tooltip>
                                            )}
                                        </div>
                                        <div className="accordion__meta">
                                            <Tag style={{ backgroundColor: '#f0f5ff', color: '#1d39c4', border: '1px solid #adc6ff' }}>
                                                {content.points || 10} Points
                                            </Tag>
                                            &nbsp;
                                            <Icon type={activeIndex === index ? 'up' : 'down'} />
                                        </div>
                                    </div>

                                    <div className={`accordion__body ${activeIndex === index ? 'open' : ''}`}>
                                        <div className="accordion__content corporate-style">
                                            <div className="accordion__section">
                                                <h4 className="corporate-label">Mission Narrative</h4>
                                                <p className="corporate-text">{content.story}</p>
                                            </div>

                                            <div className="accordion__grid">
                                                <div className="accordion__section">
                                                    <h4 className="corporate-label">Fun Fact</h4>
                                                    <div className="corporate-insight">
                                                        <Icon type="bulb" style={{ color: '#faad14', marginRight: 8 }} />
                                                        {content.fun_fact}
                                                    </div>
                                                </div>
                                                <div className="accordion__section">
                                                    <h4 className="corporate-label">Open Ended Question</h4>
                                                    <p className="corporate-text-secondary">{content.quiz?.open_ended}</p>
                                                </div>
                                            </div>

                                            <div className="accordion__grid">
                                                <div className="accordion__section">
                                                    <h4 className="corporate-label">Knowledge Check</h4>
                                                    <div className="quiz-box">
                                                        <div className="quiz-question">
                                                            <Icon type="question-circle" style={{ color: '#1890ff', marginRight: 8 }} />
                                                            {content.quiz?.multiple_choice?.question}
                                                        </div>
                                                        <ul className="quiz-options">
                                                            {content.quiz?.multiple_choice?.options?.map((opt, i) => (
                                                                <li key={i}>
                                                                    {opt}
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                </div>
                                                {content.clue && (
                                                    <div className="accordion__section">
                                                        <h4 className="corporate-label">Mission Hints</h4>
                                                        {content.clue && (
                                                            <div className="corporate-insight" style={{ marginBottom: 12 }}>
                                                                <div style={{ fontSize: '12px', color: '#8c8c8c' }}>{content.clue.narrative_content}</div>
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                            <div className="accordion__location_grid">
                                                {content.location && (
                                                    <div className="accordion__section">
                                                        <h4 className="corporate-label">Location Hints</h4>
                                                        {content.location && (
                                                            <div className="corporate-insight" style={{ marginBottom: 12 }}>
                                                                <Icon type="environment" style={{ color: '#1890ff', marginRight: 8 }} />
                                                                <strong>{content.location.name}</strong>
                                                                <div style={{ marginLeft: 24, fontSize: '12px', color: '#8c8c8c' }}>{content.location.address}</div>
                                                            </div>
                                                        )}
                                                        <div className="corporate-hints">
                                                            {content.clue?.mission_context && (
                                                                <div className="hint-item">
                                                                    <span className="hint-label">Mission Context:</span>
                                                                    <span className="hint-value">{content.clue.mission_context}</span>
                                                                </div>
                                                            )}
                                                            {content.clue?.location_clues && (
                                                                <div className="hint-item">
                                                                    <span className="hint-label">Location Clues:</span>
                                                                    <div className="tag-group" style={{ display: 'block' }}>
                                                                        {content.clue.location_clues.map((c, i) => (
                                                                            <div key={i} className="corporate-text-secondary" style={{ marginBottom: 4 }}>• {c}</div>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            )}
                                                            {content.clue?.confirmation && (
                                                                <div className="hint-item">
                                                                    <span className="hint-label">Confirmation:</span>
                                                                    <span className="hint-value" style={{ color: '#52c41a', fontWeight: 600 }}>{content.clue.confirmation}</span>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </Spin>
            </Modal>


        </Fragment >
    )
}

const mapStateToProps = state => ({
    user: state.user
})

export default connect(
    mapStateToProps,
)(ListQuest)

